import { render, staticRenderFns } from "./FontFamilyAndWeightControl.vue?vue&type=template&id=eb79b9d2"
import script from "./FontFamilyAndWeightControl.vue?vue&type=script&lang=js"
export * from "./FontFamilyAndWeightControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports